<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                        <section class="basic-elements" v-if="seizure.type">
                                <div class="row">
                                    <div class="col-sm-12">
                                    <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                                    <h2 class="content-header">{{ $t("labels.patient") }}: {{ seizure.patientId.shortId }}</h2>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="px-3">
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <h5>{{ $t("labels.type") }}</h5>
                                                        <p>
                                                            {{ seizure.type.name[$i18n.locale] ? seizure.type.name[$i18n.locale] : seizure.type.name['en'] }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <h5>Occured on:</h5>
                                                        <p>
                                                            {{ formatDate(seizure.occuredOn) }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <h5>Status:</h5>
                                                        <p>
                                                            {{ seizure.status }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 bottom-space">
                                                    <div class="form-group">
                                                        <h5>Duration:</h5>
                                                        <p>
                                                            {{ seizure.duration.name[$i18n.locale] ? seizure.duration.name[$i18n.locale] : seizure.duration.name['en'] }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <h5>Seizure blocked:</h5>
                                                        <p>
                                                            {{ seizure.seizureBlocked ? "Yes" : "No" }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <h5>Blocked with drugs:</h5>
                                                        <p>
                                                            {{ seizure.blockedWithDrugs ? "Yes" : "No" }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group">
                                                        <h5>Hospitalization:</h5>
                                                        <p>
                                                            {{ seizure.hospitalization ? "Yes" : "No" }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12" v-if="seizure.blockedWithDrugs">
                                                    <div class="form-group">
                                                        <h5>Drugs:</h5>
                                                        <table class="table table-responsive-sm" v-if="seizure.drug && seizure.drug.length > 0">
                                                            <thead>
                                                                <th>
                                                                {{ $t("labels.drug") }}
                                                                </th>
                                                                <th>
                                                                {{ $t("labels.quantity") }}
                                                                </th>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="d in seizure.drug" :key="d.id">
                                                                    <td>
                                                                        {{ d.drug.name[$i18n.locale] ? d.drug.name[$i18n.locale] : d.drug.name['en'] }}
                                                                    </td>
                                                                    <td>
                                                                        {{ d.quantity }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if="seizure.notes.length > 0">
                                                <div class="col-md-12">
                                                    <h5>Notes:</h5>
                                                    <div v-html="seizure.notes"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SeizureService from '@/services/seizure'
import moment from 'moment'

export default {
    data() {
        return {
            seizure: {}
        }
    },
    methods: {
        back() {
          this.$router.push({ name: 'home'})
        },
        formatDate(d) {
            return moment(new Date(d)).format('YYYY-MM-DD HH:mm')
        }
    },
    mounted: async function() {
        let result = await SeizureService.show(this.$route.params.id)
        if (result) {
            this.seizure = result.data
        }
    }
}
</script>

<style lang="scss">
    .px-3 {
        padding: 15px 0 15px 0;
    }
</style>


